module.exports = __webpack_public_path__ + "static/media/favourite_1.9571d62c.png";